module.exports = __webpack_public_path__ + "img/01.bf15d5c8.jpg";